import { AxiosRequestConfig, AxiosError } from "axios";
import {
  isAccessTokenExpired,
  getRefreshToken,
  getAccessToken,
} from "./auth/authenticationService";
import { setUserTokenByRefreshToken } from "./auth/setUserTokenByRefreshToken";

export const requestInterceptor = async (
  request: AxiosRequestConfig
): Promise<AxiosRequestConfig> => {
  if (isAccessTokenExpired()) {
    const refreshToken = getRefreshToken();
    await setUserTokenByRefreshToken(refreshToken);
  }

  const accessToken = getAccessToken();

  if (accessToken) {
    request.headers.Authorization = `Bearer ${accessToken}`;
  }

  return request;
};

export const responseErrorInterceptor = (error: AxiosError) => {
  if (error.response?.status === 401) {
    const { pathname } = window.location;
    const { search } = window.location;
    window.location.replace(
      `/auth/password/identificacao?referrer=${pathname}${search}`
    );
  }

  return Promise.reject(error.response);
};
